import React from 'react';
import './Home.scss';
import OverlaySection from '../../SmallComponents/OverlaySection';
import BlackTshirt from '../../assets/images/black-tshrit.png';
import CustomGrid from '../../SmallComponents/CustomGrid';
import Sloutions from '../../SmallComponents/SolutionComponent';


const Home: React.FC = () => {
  
  return (
    <div className="home">
      <header className="home__header">
      <div className="home__image">
          <img src={BlackTshirt} alt="Cazz Karo Shirt" />
        </div>
        <div className="home__content">
          <h1>MENTAL YOUR LOOK WITH <span>YAMUNA MYMENTAL</span></h1>
          <p>Crafting styles that redefine individuality and confidence.</p>
          <div className="home__buttons">
            <div><a href='/about' className="btn primary">Know More</a></div>
            <div> <a href='/products' className="btn secondary">See Products</a></div>
          </div>
        </div>
      </header>
      <OverlaySection />
      <Sloutions/>
    <CustomGrid/>
    <div className="content-box">
      <div className="content-box-inner">
        <h2>Brief Introduction of <br></br>Seamless Clothing Knitting Process</h2>
        <p>
          Seamless clothing is basically worn close to the body and directly touches the skin, so
          the feeling of wearing is particularly important. Nylon & spandex, nylon & polyester &
          spandex, polyester & elastane, nylon & cotton (or Modal) & elastane, etc., all have good
          moisture absorption and antistatic properties after special dyeing processes, and their
          protein composition is similar to human skin, so it is soft and comfortable.
        </p>
        <p>
          Although the cellulose fiber such as cotton hemp also is natural fiber, hygroscopic
          performance is right, regard seamless knitwear as comfortable also, but their softness
          and tactility are far inferior to super high-quality seamless activewear.
        </p>
        <h3>A Brief Introduction of Seamless Garment Weaving Technology</h3>
        <ol>
          <li>
            <strong>Weaving/ Knitting Equipment and Parameters</strong>
            <ul>
              <li>
                <strong>The Equipment</strong>
                <br />
                The sm8-TOP2 seamless knitting circular machine produced by SANTONI, Italy, is widely
                used by seamless activewear manufacturers in China at present. It is a single-sided
                once-forming computerized knitting jacquard machine with eight paths of yarn, and
                each path has two independent jacquard points.
              </li>
              <li>
                <strong>Parameters</strong>
                <br />
                Electronic seamless apparel circular knitting machine with barrel diameter of 30-40cm
                (12-16 inches). The speed of 110 r/min; Needle selector for each 2.
              </li>
            </ul>
          </li>
          <li>
            <strong>Pre-knitting Process</strong>
            <p>
              Let’s take the example with silk yarn production way to talk about pre-knitting
              process. The silk has sericin and high rigidity. It is easy to appear brittle broken
              and missing needles and other defects when weaving, so it needs to be dealt a bit
              before weaving.
            </p>
            <p>
              If the twisted silk manufactured by the general polyester factory is used, it needs to
              go through the following processing: the twisted raw silk is placed in the solution
              containing softening agent (such as ENS-I) and foaming agent (such as HV-302), bath
              ratio 1:20, temperature 40-50℃ for 18 hours, after drying, winding, and then on the
              machine weaving.
            </p>
            <p>
              If the simple raw silk directly provided by the factory is used, it is necessary to
              put the raw silk in a barrel in a vacuum container containing the treatment solution
              (generally, the solution of Swire oil with bath ratio of 1:10, 109/L) at room
              temperature, so that the treatment solution can quickly penetrate into the inner layer
              of the coil and the inside of the sericin, and the machine is woven after processing.
            </p>
          </li>
          <li>
            <strong>Programming</strong>
            <p>
              Then, deal with program design. After determining the number of nozzles and paths, the
              program is programmed in the special programming system according to the choice of
              nozzles and paths, and attention should be paid to timely refueling and air suction
              programming design.
            </p>
            <p>
              The selection of nozzles should be determined according to the performance of the
              machine itself. The front nozzles are in the inner layer and the back nozzles are in
              the outer layer. When weaving the fabric covered with one material and another
              material, the sand nozzles should be appropriately selected according to the needs.
            </p>
          </li>
          <li>
            <strong>Run on the Machine</strong>
            <p>
              After the program is prepared, the machine began to debug. In this process, the size
              should be strictly controlled, and the program should be repeatedly modified until the
              requirements are met.
            </p>
          </li>
        </ol>
      </div>
    </div>
    </div>
  );
};

export default Home;
